module.exports = __webpack_public_path__ + "static/img/lyfwcx.0ea8d7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/lyfwcx.png
// module id = +eu+
// module chunks = 1